<span class="inline-block w-full min-h-full bg-white shadow-[0_6px_14px_#00000029] px-1 py-1 text-xs text-[#0d0d0d] text-center break-words rounded-md absolute mx-auto z-20
  after:absolute after:content-[''] after:w-0 after:h-0 after:left-1/2 after:-translate-x-1/2
  after:border-solid after:border-l-4 after:border-l-transparent after:border-r-4 after:border-r-transparent after:border-b-5 after:border-b-white after:z-20"
  [ngClass]="{
    'after:rotate-180 after:top-full': tooltipTextTopside,
    'after:bottom-full': !tooltipTextTopside
  }"
>{{ text }}</span>
